import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { deleteAdminEnetrpriseRoute } from '../api/constant';
import { adminEmployersList, adminEnterprisesList } from '../constants';

type useDeleteEnterpriseProps = {
    setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useDeleteEnterprise = ({
    setAlertText = () => { },
}: useDeleteEnterpriseProps) => {
    const client = useQueryClient();

    const { mutate: deleteEnterprise, isLoading: isdeleteEnterpriseLoading } =
        useMutation({
            mutationFn: (variables: {
                user_id: number | string;
            }) =>
                axiosInstance
                    .post(deleteAdminEnetrpriseRoute, variables, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                client.invalidateQueries(adminEmployersList);
                client.invalidateQueries(adminEnterprisesList);
                setAlertText('');
            },
            onError: () => {
                setAlertText(errorMessage);
            },
        });
    return {
        deleteEnterprise,
        isdeleteEnterpriseLoading,
    };
};
